import Big from "big.js";

const AmountWithCurrency = ({
  amount = 0,
  maximumSignificantDigits = 10,
  locale = "en-IN",
  currency = "INR",
  style,
  className,
}) => {
  let formattedAmount;
  try {
    const bigNumber = new Big(+amount);
    const fixedValue = bigNumber.toFixed(); //long value
    const numericalValue = bigNumber.valueOf(); //can be exponent

    if (fixedValue?.length > 15) {
      formattedAmount = bigNumber.toExponential(6);
    } else {
      formattedAmount = new Intl.NumberFormat(locale, {
        maximumSignificantDigits: maximumSignificantDigits,
        currency: currency,
        style: "decimal",
      }).format(numericalValue);
    }
  } catch (e) {
    //error in Big code
    formattedAmount = +amount || 0;
  }

  return (
    <div className={className} style={style}>
      <span>₹</span>
      <span>{formattedAmount}</span>
    </div>
  );
};

export default AmountWithCurrency;
